import React from "react";
import { useKT } from "../i18n/kt";

/**
 * Who weaves with the weaver: a helper, the weaver alone (paid the alone allowance), or no helper
 * needed for this work (no allowance).
 */
export type HelperMode = "WITH_HELPER" | "ALONE" | "NOT_NEEDED";

export const helperModeOf = (m?: string | null): HelperMode => (m === "ALONE" || m === "NOT_NEEDED" ? m : "WITH_HELPER");

export const helperModeLabel = (m?: string | null): string =>
  m === "NOT_NEEDED" ? "Helper not needed" : m === "ALONE" ? "Working alone" : "With helper";

export const HelperModeChips = ({ value, onChange }: { value: HelperMode; onChange: (m: HelperMode) => void }) => {
  const { t } = useKT();
  return (
    <div className="kr-chips" role="radiogroup" aria-label={t("Helper")} style={{ marginBottom: 8 }}>
      {(
        [
          ["WITH_HELPER", "With helper"],
          ["ALONE", "Weaver alone"],
          ["NOT_NEEDED", "Helper not needed"],
        ] as [HelperMode, string][]
      ).map(([m, label]) => (
        <button key={m} type="button" role="radio" aria-checked={value === m} className={`kr-choice${value === m ? " is-on" : ""}`} onClick={() => onChange(m)}>
          {t(label)}
        </button>
      ))}
    </div>
  );
};
